import perfisBA from './perfis'
import tipoConversa from '../tipoConversa'
import status from '../status'
const { setores } = require('./setor').default

const perfis = Object.keys(perfisBA)

const rendaEnum = {
  '0a0': 'Menos que 1 salário mínimo',
  '1a3': '1 a 3 salários mínimos',
  '4a5': '4 a 5 salários mínimos',
  'mais5': 'Mais de 5 salários mínimos'
}

const acoesRetornarRevisao = ['FINALIZAR.SISTEMA.TITULO']

const verificarDespachoSemTexto = (usuario) => {
  return false
}

const caixaAssinaturaConjunta = {
  textoButtonAssinatura: 'Assinar',
  visualizarModalAssinatura: true,
  visualizarModalAnalise: false,
  funcaoExibirModal: 'ASSINAR'
}

const caixaAnaliseConjunta = {
  textoButtonAssinatura: 'Analisar todos',
  visualizarModalAssinatura: false,
  visualizarModalAnalise: true,
  funcaoExibirModal: 'ASSINAR_TITULOS'
}

const caixaLaudo = {
  textoButtonAssinatura: 'Gerar todos',
  visualizarModa: true,
  funcaoExibirModal: 'GERAR_LAUDO'
}

const caixaValidacaoConjunta = {
  textoButtonAssinatura: 'Validar selecionados',
  visualizarModalAssinatura: false,
  visualizarModalAnalise: false,
  funcaoExibirModal: 'VALIDAR_SELECIONADOS'
}

const montarListagem = {
  'ASSINATURA_CONJUNTA': caixaAssinaturaConjunta,
  'ANALISE_CONJUNTA': caixaAnaliseConjunta,
  'ANALISE_COLETIVA': caixaAnaliseConjunta,
  'AGUARDANDO_VALIDACAO_ANALISE': caixaValidacaoConjunta,
  'LAUDO': caixaLaudo
}

const exibirCSV = () => false

const filtroDefaultSituacao = () => {
  return [...perfis]
}

const separatorByUnderscore = (string = '') => {
  if (!string.includes('_')) return string
  else return string.split('_')[0]
}

const findUsersDj = async (callBack) => {
  return {
    coordenador: await callBack(perfisBA.COORDENADOR_NAJ)
  }
}

const findUsersDRV = async (callBack) => {
  return {
    vistoriadores: await callBack([])
  }
}

const findUsersConsultoresJuridicos = async (callBack) => {
  return {
    consultoresJuridicos: await callBack(perfisBA.COORDENADOR_NAJ)
  }
}

const tipoConversaPasseivelDeArquivamento = [
  tipoConversa.NOTIFICACAO_INTERESSADO,
  tipoConversa.SOLICITACAO_RETIFICACAO
]

const isConversaPassivelDeArquivamento = (tipo) => tipoConversaPasseivelDeArquivamento.includes(tipo)

const getUserBySetor = (callBack) => {
  return callBack(setores.NAJ)
}

const filtroDefaultResponsavel = () => {
  return [...perfis]
}

const filtroDefaultReceita = () => {
  return []
}

const filtroDefaultOrdemServico = () => {
  return []
}

const filtroDefaultFuncao = () => {
  return [perfisBA.TECNICO_DE_CAMPO]
}

const filtroDefaultDataVencimento = () => {
  return [perfisBA.COORDENADOR_CAF]
}

const filtroDefaultMunicipio = () => {
  return Object.entries(perfisBA).map(([, value]) => value)
}

const filtroDefaultResponsavelPortaria = () => {
  return []
}

const perfisRegerar = () => {
  return []
}

const montarFiltroRapido = async (opcoes) => {
  return {
    tipoRuralPendencia: opcoes[0].pendencia.find(p => p.id === 1).value,
    tipoSemRuralPendencia: opcoes[0].pendencia.find(p => p.id === 2).value,
    informacaoPendencia: opcoes[0].pendencia.find(p => p.id === 1).value,
    informacaoSemPendencia: opcoes[0].pendencia.find(p => p.id === 2).value
  }
}

const perfisGestaoProcesso = []
const isVisualizarGestaoProcessos = (perfil) => perfisGestaoProcesso.includes(perfil)
const tiposModeloDefault = [1, 4, 8]
const perfilSetor = (callBack, setor) => {
  return callBack(setor)
}

function isCheckedRetornarEmissaoReurb (value) {
  return false
}

const pegarAcao = (despacho, acoesRadio, action) => {
  return [].includes(despacho.processo.tipo.codigo) ? acoesRetornarRevisao[1]
    : acoesRadio.filter(item => item.valor.includes(action))
}

const isRevisao = (action) => {
  return action === 'REVISAO'
}

const isRetorno = (action) => {
  return action === 'RETORNO'
}

const isNovaPortaria = (despacho) => {
  return despacho?.tituloDespacho?.tituloProcessoDTO?.novaPortaria
}

export default {
  isCheckedRetornarEmissaoReurb,
  isGcgCgir: (setor) => false,
  perfilSetor,
  mensagemSucessoConferenciaTitulo: (respostaFinalizar) => {
    return 'Solicitação enviada com sucesso!'
  },
  getOpcoesCredenciadoByPerfil: (perfil) => [],
  separatorByUnderscore,
  cadastro: {
    exibirMapa: {
      setores: [],
      status: []
    },
    exibirAnexosBloqueio: {
      setores: []
    },
    exibirAnexosMonitoramento: {
      setores: []
    },
    exibirMapaTecnicoCampo: {
      setores: [],
      status: []
    },
    exibirCodigoEstado: {
      setores: [],
      status: []
    },
    exibirResponsavel: {
      setores: [setores.TECNICO_DE_CAMPO],
      status: [status.EM_ANALISE, status.AGUARDANDO_ANALISE]
    },
    pegarResponsavel: {
      setores: [setores.TECNICO_DE_CAMPO],
      status: [status.AGUARDANDO_ANALISE, status.EM_REVISAO]
    },
    tiposDocumentosRurb: {
      tipos: [],
      obrigatorios: []
    },
    tiposDocumentosGabinete: {
      tipos: [],
      obrigatorios: []
    },
    exibirModelos: {
      tipos: ['ANALISE', 'TITULO_CERTIDAO']
    },
    naoExibirModelos: {
      perfis: [perfisBA.GOVERNADOR]
    },
    exibirModeloTitulo: true,
    perfisModeloTitulo: {
      perfis: []
    },
    exibirModeloDespachoReurb: true,
    perfisModeloDespachoReurb: {
      perfis: [perfisBA.COORDENADOR_NDI, perfisBA.ANALISTA_NDI,
        perfisBA.COORDENADOR_CAF, perfisBA.ANALISTA_NOT,
        perfisBA.COORDENADOR_NOT, perfisBA.ANALISTA_NAJ, perfisBA.COORDENADOR_NAJ,
        perfisBA.ANALISTA_NUTIT, perfisBA.COORDENADOR_NUTIT, perfisBA.SUPERINTENDENTE_GAB, perfisBA.ARQUIVO]
    },
    exibirModeloDespachoVistoria: false,
    perfisModeloDespachoVistoria: {
      perfis: []
    },
    exibirModeloJustificativa: false,
    perfisModeloJustificativa: {
      perfis: []
    },
    exibirModeloExtratoSentenca: true,
    perfisModeloExtratoSentenca: {
      perfis: [perfisBA.COORDENADOR_NUTIT, perfisBA.ANALISTA_NUTIT]
    },
    exibirModeloDespacho: false,
    possuiTitulo: {
      acoes: []
    },
    exibirBotoesDecisao: {
      setores: []
    },
    statusBotoesDecisao: {
      status: []
    },
    podeInserirAnotacao: {
      perfis: [],
      acoes: []
    },
    decisoes: {},
    getUserBySetor,
    findUsersDj,
    findUsersDRV,
    findUsersConsultoresJuridicos,
    showSelecionaUsuarioDj: [],
    optionsRadios: [],
    radiosGSF: [],
    radiosDIPRE: [],
    showSelecionaUsuario: [],
    perfilNotToShowSelecionaUsuario: [],
    radiosDJ: {},
    notShowCardInfoTecnicoCampo: {
      status: ['EM_REVISAO'],
      funcoes: ['VISTORIADOR']
    }
  },
  notificarInteressado: {
    perfis: Object.entries(perfisBA).filter(([, value]) => value !== perfisBA.TECNICO_DE_CAMPO).map(([, value]) => value)
  },

  solicitarRetificacao: {
    perfis: [
      perfisBA.COORDENADOR_NDI,
      perfisBA.ANALISTA_NDI,
      perfisBA.COORDENADOR_NOT,
      perfisBA.ANALISTA_NOT,
      perfisBA.COORDENADOR_NAJ,
      perfisBA.ANALISTA_NAJ,
      perfisBA.COORDENADOR_CAF,
      perfisBA.SUPERINTENDENTE_GAB,
      perfisBA.COORDENADOR_NUTIT,
      perfisBA.ANALISTA_NUTIT,
      perfisBA.ARQUIVO,
      perfisBA.EXTERNO,
      perfisBA.RELATORIOS,
      perfisBA.PREFEITURA,
      perfisBA.PRODUTIVIDADE,
      perfisBA.FINANCEIRO,
      perfisBA.ADMINISTRADOR_DE_ACESSO,
      perfisBA.GOVERNADOR,
      perfisBA.ASSESSOR_JURIDICO
    ]
  },

  filtro: {
    placeholder: 'Número do processo, Nome/Razão social do Interessado, CPF/CNPJ do interessado, ou Tipo do processo',
    showFiltroTipoProcessoMultiplo: false,
    showFiltroDataEmissaoTitulo: false,
    filtroSituacao: {
      CAIXA_ENTRADA: filtroDefaultSituacao(),
      EM_ANALISE: filtroDefaultSituacao(),
      AGUARDANDO_VALIDACAO_ANALISE: filtroDefaultSituacao(),
      INFORMACAO_SOLICITADA: filtroDefaultSituacao(),
      CAIXA_AGUARDANDO_OS: filtroDefaultSituacao(),
      EM_ANALISE_OS: filtroDefaultSituacao(),
      DAE: [],
      ARQUIVOS: filtroDefaultSituacao(),
      CAIXA_PORTARIA_VALIDACAO: filtroDefaultSituacao(),

      CAIXA_PORTARIA_EMISSAO: filtroDefaultSituacao(),

      PROCESSO_ARQUIVADO: [],

      TITULO_CERTIDAO: filtroDefaultSituacao(),

      PROCESSOS_ASSINADOS: filtroDefaultSituacao(),
      TITULOS_PARA_ENTREGA: [],
      CADASTROS_PENDENTES_GEORREFERENCIAMENTO: [perfisBA.TECNICO_DE_CAMPO],
      PUBLICACAO: filtroDefaultSituacao()
    },

    filtroSituacaoAssinatura: {
      ASSINATURAS: ['SUPERINTENDENTE_GAB']
    },

    filtroCredenciado: {
      RELATORIO_GRF_CAF_CREDENCIADOS: []
    },

    filtroVistoriador: {
      CAIXA_ENTRADA: [],
      EM_ANALISE: [],
      AGUARDANDO_VALIDACAO_ANALISE: []
    },

    filtroCredenciadoGeo: {
      RELATORIO_GRF_CAF_CREDENCIADOS: []
    },

    filtroResponsavel: {
      CAIXA_ENTRADA: filtroDefaultResponsavel(),
      EM_ANALISE: [...filtroDefaultResponsavel()],
      AGUARDANDO_VALIDACAO_ANALISE: filtroDefaultResponsavel(),
      PROCESSO_ARQUIVADO: [perfisBA.SUPERINTENDENTE_GAB, perfisBA.COORDENADOR_CAF, perfisBA.ARQUIVO],
      EM_ANALISE_OS: filtroDefaultResponsavel(),
      CAIXA_AGUARDANDO_OS: filtroDefaultResponsavel(),
      ATUALIZACAO_BASE: [],
      CAIXA_PORTARIA: filtroDefaultResponsavelPortaria(),
      CAIXA_PORTARIA_VALIDACAO: filtroDefaultResponsavelPortaria(),
      CAIXA_PORTARIA_EMISSAO: filtroDefaultResponsavelPortaria(),
      TITULOS_PARA_ENTREGA: []
    },

    filtroReceita: {
      CAIXA_ENTRADA: filtroDefaultReceita(),
      EM_ANALISE_OS: filtroDefaultReceita(),
      CAIXA_AGUARDANDO_OS: filtroDefaultReceita()
    },

    filtroMunicipio: {
      CAIXA_ENTRADA: filtroDefaultMunicipio(),
      EM_ANALISE: filtroDefaultMunicipio(),
      AGUARDANDO_VALIDACAO_ANALISE: filtroDefaultMunicipio(),
      EM_ANALISE_OS: filtroDefaultMunicipio(),
      CAIXA_AGUARDANDO_OS: filtroDefaultMunicipio(),
      TITULO_CERTIDAO: [],
      PROCESSOS_ASSINADOS: [],
      PUBLICACAO: filtroDefaultMunicipio()
    },

    filtroOrdemServico: {
      CAIXA_ENTRADA: filtroDefaultOrdemServico(),
      CAIXA_ENTRADA_OS: filtroDefaultOrdemServico(),
      EM_ANALISE_OS: filtroDefaultOrdemServico(),
      CAIXA_AGUARDANDO_OS: filtroDefaultOrdemServico(),
      EM_ANALISE: filtroDefaultOrdemServico(),
      INFORMACAO_SOLICITADA: filtroDefaultOrdemServico(),
      EDITAL_PUBLICACAO: [],
      ORDEM_SERVICO: []
    },

    filtroFuncao: {
      CAIXA_ENTRADA: filtroDefaultFuncao(),
      EM_ANALISE_OS: filtroDefaultFuncao(),
      CAIXA_ENTRADA_OS: filtroDefaultFuncao(),
      CAIXA_AGUARDANDO_OS: filtroDefaultFuncao(),
      EM_ANALISE: filtroDefaultFuncao(),
      INFORMACAO_SOLICITADA: filtroDefaultOrdemServico()
    },

    filtroDataVencimento: {
      CAIXA_ENTRADA: filtroDefaultDataVencimento(),
      EM_ANALISE_OS: filtroDefaultDataVencimento(),
      CAIXA_AGUARDANDO_OS: filtroDefaultDataVencimento(),
      DAE: []
    },

    filtroStatusOrdemServico: {
      EDITAL_PUBLICACAO: [],
      ORDEM_SERVICO: []
    },

    filtroTitulo: {
      TITULO_CERTIDAO: []
    },

    filtroSituacaoTituloCertidao: {
      TITULO_CERTIDAO: [perfisBA.SUPERINTENDENTE_GAB, perfisBA.COORDENADOR_NUTIT]
    },

    filtroRua: {
      CAIXA_ENTRADA: [],
      EM_ANALISE: [],
      ANALISE_CONJUNTA: []
    },

    filtroBairro: {
      CAIXA_ENTRADA: [],
      EM_ANALISE: [],
      ANALISE_CONJUNTA: []
    },

    filtroRemessa: {
      CAIXA_ENTRADA: [],
      EM_ANALISE: [],
      ANALISE_CONJUNTA: []
    },

    filtroQuadra: {
      CAIXA_ENTRADA: [],
      EM_ANALISE: [],
      ANALISE_CONJUNTA: []
    },

    filtroOS: {
      CAIXA_ENTRADA: [],
      EM_ANALISE: [],
      ANALISE_CONJUNTA: []
    },
    filtroClausulaResolutiva: {
      CAIXA_ENTRADA: [],
      EM_ANALISE: [],
      ANALISE_COLETIVA: []
    },
    filtroNumeroRecibo: {
      CADASTROS_PENDENTES_GEORREFERENCIAMENTO: [perfisBA.TECNICO_DE_CAMPO]
    },
    filtroCpf: {
      CAIXA_ENTRADA: [],
      EM_ANALISE: [],
      PROCESSO_ARQUIVADO: [],
      PUBLICACAO: []
    },
    filtroDataChegada: {
      CAIXA_ENTRADA: [],
      EM_ANALISE: [],
      PROCESSO_ARQUIVADO: [],
      PUBLICACAO: []
    },
    filtroCadastrante: {
      CAIXA_ENTRADA: filtroDefaultResponsavel(),
      EM_ANALISE: filtroDefaultResponsavel(),
      PROCESSO_ARQUIVADO: filtroDefaultResponsavel(),
      PUBLICACAO: filtroDefaultResponsavel()
    }
  },

  hasPermissaoNotificar: {
    PERFIS_PERMITIDOS: [perfisBA.COORDENADOR_NDI, perfisBA.ANALISTA_NDI,
      perfisBA.COORDENADOR_CAF, perfisBA.ANALISTA_NOT,
      perfisBA.COORDENADOR_NOT, perfisBA.ANALISTA_NAJ, perfisBA.COORDENADOR_NAJ,
      perfisBA.ANALISTA_NUTIT, perfisBA.COORDENADOR_NUTIT, perfisBA.SUPERINTENDENTE_GAB, perfisBA.ARQUIVO],
    PERFIS_EXCLUIDOS: []
  },

  despacho: {
    perfisInserirAnotacao: [],
    perfisInserirVisualizarAnotacao: []
  },

  tiposDocumentosVistoria: {
    tipos: [
      {id: 58, codigo: 'LAUDO_VISTORIA', descricao: 'Laudo de Vistoria'},
      {id: 59, codigo: 'OUTROS_VISTORIADOR', descricao: 'Outros'},
      {id: 84, codigo: 'RELATORIO_VISTORIA', descricao: 'Relatório de Vistoria'},
      {id: 204, codigo: 'FOTOGRAFIAS_IMOVEL', descricao: 'Arquivo Fotográfico'}
    ],
    obrigatorios: [
      {id: 58, codigo: 'LAUDO_VISTORIA', descricao: 'Laudo de Vistoria'},
      {id: 84, codigo: 'RELATORIO_VISTORIA', descricao: 'Relatório de Vistoria'},
      {id: 204, codigo: 'FOTOGRAFIAS_IMOVEL', descricao: 'Arquivo Fotográfico'}
    ]
  },

  tiposDocumentosPortaria: {
    tipos: [],
    obrigatorios: []
  },

  tiposDocumentosSpu: {
    tipos: [],
    obrigatorios: []
  },

  tiposDocumentosArquivosPublicacao: {
    tipos: [],
    obrigatorios: []
  },

  tiposDocumentosRelatorio: {
    tipos: [],
    obrigatorios: []
  },

  tiposDocumentosPublicacaoEdital: {
    tipos: [],
    obrigatorios: []
  },

  tiposDocumentosDecreto: {
    tipos: [],
    obrigatorios: []
  },

  tiposDocumentosPge: {
    tipos: [],
    obrigatorios: []
  },

  tiposDocumentosDecisaoFinal: {
    tipos: [],
    obrigatorios: []
  },

  tiposDocumentosPds: {
    tipos: [],
    obrigatorios: []
  },

  tiposDocumentosIncra: {
    tipos: [],
    obrigatorios: []
  },

  tiposDocumentosGeorreferenciamento: {
    tipos: [],
    obrigatorios: []
  },
  textoDocumentos: {
    OUTROS: `Complemento para informações ou registros necessários ao processo de regularização fundiária, podendo incluir detalhes adicionais, esclarecimentos ou documentos específicos que não estejam previstos nas categorias principais.`
  },

  messages: {
    headerTituloCertidao: 'Título',
    headerExtratoSentenca: 'Extrato de sentença',
    headerCertidaoArea: 'Certidão de Área',
    menuTituloCertidao: 'Títulos',
    outorgante: 'INSTITUTO DE COLONIZAÇÃO E TERRAS DO MARANHÃO'
  },

  isParecer: {
    JURIDICO: true
  },

  labelVisualizacaoProcesso: {
    etapaQualificacao: {
      area: 'Qual o tamanho estimado da área?',
      desintrusado: 'Você é desintrusado de terra indígena ou de unidade de conservação?',
      contestacaoTerceiros: 'Há legítima contestação de terceiros sob a área que pretende regularizar?',
      cargoPublico: 'Você e/ou seu cônjuge/convivente exerce cargo ou função pública em órgão fundiário?',
      dataAquisicaoImovel: 'Data da aquisição do imóvel:',
      dataPosseCargopublico: 'Data da posse no cargo público:',
      possuiImovelRuralTitulado: ' Você e/ou seu cônjuge/convivente possui outro imóvel rural titulado?',
      ocupaImovel: 'Pratica cultura efetiva e exerce ocupação mansa e pacífica por mais de 05 (cinco) anos?',
      exploracaoAgricola: 'A principal atividade exercida pelo requerente é a exploração agrícola do imóvel?',
      beneficiarioReformaAgraria: 'O interessado(a) e/ou o cônjuge ou companheiro, se for o caso, já foi/foram beneficiado(s) por programa de reforma agrária e/ou de regularização fundiária?',
      cunhoRecreativo: 'Exerce atividade(s) de cunho recreativo(s) familiar?',
      moradiaHabitual: 'Exerce moradia habitual?',
      trabalhoEscravo: 'Há prática ou aceitação a exploração de trabalho escravo ou degradante, bem como exploração de mão de obra infantil e adolescente (salvo os casos previstos na Lei Federal n° 8.069/90)?',
      brasileiroNatoNaturalizado: 'Você é brasileiro nato ou naturalizado?',
      ocupantePrimitivo: 'É ocupante primitivo? ',
      dataOcupacaoPrimitiva: 'Data da ocupação primitiva:',
      praticaCultutraEfetiva: 'Há prática de cultura efetiva no imóvel?',
      naturezaGlebaPretendida: 'Reconhece a natureza devoluta da gleba pretendida e da impossibilidade de aliená-la antes de decorrido o prazo estabelecido pelo Estado?'
    },
    etapaInteressado: {
      titleSocioRepresentante: 'Sócio/Representante Legal'
    },
    etapaImovel: {
      numeroRecibo: 'Número do Recibo do CAR:',
      possuiImovel: 'Possui outros imóveis rurais em território nacional?'
    },
    etapaDestinacaoUsoImovel: {
      destinacaoUsoImovel: 'Destinação e uso do imóvel:'
    }
  },

  opcoesFiltroRapido: [
    {
      id: 1,
      titulo: 'GERAL',
      pendencia: [
        { id: 2, label: 'Sem pendência', value: false },
        { id: 1, label: 'Com pendência', value: false }
      ]
    }
  ],

  showChatbotButton: false,

  analiseAutomatizada: {
    NAO_ONEROSO: {
      conclusao: ''
    },
    ONEROSO: {
      conclusao: ''
    }
  },

  visualizarDocumentosPDF: {
    active: true,
    perfis: Object.keys(perfisBA),
    extensaoImagens: ['jpeg', 'png', 'jpg'],
    extensaoVisualizar: ['jpeg', 'png', 'jpg', 'pdf']
  },

  usePDFViewerOld: {
    active: true,
    minByteLength: 1048576
  },

  disableCadastrarCustas: true,

  montarFiltroRapido,

  exibirCSV,

  isConversaPassivelDeArquivamento,

  defaultModeloDespacho: 4,

  showValidacaoDocumentos: {
    perfis: [perfisBA.ANALISTA_NDI, perfisBA.COORDENADOR_NDI, perfisBA.COORDENADOR_NAJ, perfisBA.ANALISTA_NAJ]
  },

  visualizarBotaoVincularPessoa: false,
  visualizarBotaoSinalizarPendencia: false,

  rulesButtonConditionPdf: {
    show: true,
    tiposProcessos: [
      'REGULARIZACAO_URBANA',
      'REURB-S',
      'ONEROSO',
      'NAO_ONEROSO',
      'Não Oneroso',
      'Oneroso',
      'INFORMACOES',
      'PEAEX',
      'TEQ',
      'PEAES_FILHO',
      'TQ',
      'PEAS',
      'CANCELAMENTO_CLAUSULA_RESOLUTIVA'
    ],
    perfisDisableButtons: []
  },

  rulesButtonConditionZip: {
    show: true
  },

  rulesButtonConditionCopia: {
    show: false,
    perfisEnabled: []
  },

  showVisualizarFluxo: false,

  rulesConditionCompareTab: {
    show: false,
    tiposProcessos: []
  },

  isVisualizarGestaoProcessos,
  tiposModeloDefault,
  rendaEnum,
  isOpcoesGeo: () => false,
  telaFinal: 1,
  getMensagemEncaminhamentoTitulo: (codigo, acao, mensagemConfirmacao) => {
    switch (codigo) {
      case 'CERTIDAO_TITULO':
        if (this.acoesRetornarRevisao[1] === acao) {
          return 'Processo enviado para o setor GP.'
        } else if (this.acoesRetornarRevisao[0] === acao) {
          return 'Solicitação enviada com sucesso!'
        } else if (this.tipo === 'EMITIR_TITULO') {
          return 'Certidão emitida com sucesso.'
        } else if (this.tipo !== 'EMITIR_TITULO') {
          return 'Certidão conferida com sucesso.'
        }
        break
      case 'NAO_ONEROSO':
      case 'ONEROSO':
      case 'TQ':
      case 'TEQ':
      case 'PEAEX':
      case 'PEAS':
        return 'Título emitido com sucesso!'
    }
  },
  showCsvButtonPermissions: [],
  acoesRetornarRevisao,
  perfisRegerar,
  showGeorreferenciamentoAnexarDocumentosEShape: false,
  verificarDespachoSemTexto,

  desarquivamentoProcesso: {
    emitirBoleto: false,
    regrasExclusaoTipoProcesso: (tipoProcesso) => {
      return [].find(tipo => tipo === tipoProcesso)
    }
  },

  montarListagem,
  criarModelos: {
    perfisExcluidos: [],
    perfisExcecoes: []
  },
  tiposProcessoFisico: [],

  isDisabled (item, showButtonRegerar, usuario) {
    return usuario && usuario.perfilSelecionado.setor.codigo === 'CAF' && (item.disabled || item.retificacao || item.conversaAberta)
  },
  getAcao: (despacho, acoesRadio, acao) => {
    return isRevisao(acao) || isRetorno(acao)
      ? acoesRadio.filter(action =>
        isNovaPortaria(despacho) ? acoesRetornarRevisao[1] === action.valor : pegarAcao(despacho, acoesRadio, acao)
      )
      : acoesRadio.filter(
        action => !acoesRetornarRevisao.includes(action.valor)
      )
  },
  isAnaliseAutomatizada: (groupAnaliseAutomatizada, analiseManual, processo) => {
    return groupAnaliseAutomatizada && !analiseManual
  },
  continuarAnaliseManual: (_this, processo) => {
    _this.$router.push({
      name: 'analise/analisar',
      params: {
        idProcesso: processo.id,
        acaoCaixa: 'ANALISE'
      }
    })
    return false
  },
  tiposImagensReurb: [],
  conselhos: [ { value: 'CREA', label: 'CREA' },
    { value: 'CFTA', label: 'CFTA' },
    { value: 'CFT', label: 'CFT' },
    { value: 'CRT', label: 'CRT' } ],
  setoresArquivamentoTecnicoCampo: ['NAO_ONEROSO'],
  showAcaoDowloadDocumentos: () => { return true },
  showFiltroTipoMultiplo: false,
  fluxosAssinatura: [],
  selectItem (item, listaIDs) {
    if (!listaIDs) {
      listaIDs = []
    }
    const index = listaIDs.indexOf(item.id)
    if (index !== -1) {
      listaIDs.splice(index, 1)
    } else {
      listaIDs.push(item.id)
    }
  },

  cadastrarProtesto: {
    perfis: [
      perfisBA.COORDENADOR_NDI,
      perfisBA.ANALISTA_NDI,
      perfisBA.COORDENADOR_NOT,
      perfisBA.ANALISTA_NOT,
      perfisBA.COORDENADOR_NAJ,
      perfisBA.ANALISTA_NAJ
    ]
  },

  cancelarProtesto: {
    perfis: [
      perfisBA.COORDENADOR_NAJ,
      perfisBA.ANALISTA_NAJ
    ]
  },
  hasRetificacaoOnline: false,
  showTotalListagem: false,
  hasModuloRelatorioPrazo: false
}



// WEBPACK FOOTER //
// ./src/utils/ba/regrasAnalise.js